module.exports = __webpack_public_path__ + "img/favoritos.d954c2c3.jpg";